import { type Entity } from '@tunasong/schemas'
import type { Persisted } from '@tunasong/schemas'

export const getIFrameUrl = (item: Persisted<Entity>) => {
  const iFrameCode = `<iframe src="https://tunasong.com/embed?entityId=${item?.id}" style="border: 0; width: 100%; height: 250px" />`
  return iFrameCode
}
